<template>
  <div class="container-fluid mt-3">
    <div class="row">
      <div class="report col">
        <div class="d-flex justify-content-end">
          <!-- New filter button and search form start -->
          <div class="col d-flex gap-2 justify-content-end right-margin">
            <button
              class="btn btn-primary btn-sm allCategories dropdown-toggle"
              type="button"
              data-bs-toggle="dropdown"
              aria-expanded="false"
            >
              <span>{{ searchConcept }}</span>
            </button>

            <ul class="dropdown-menu">
              <li>
                <a
                  class="dropdown-item mt-1"
                  href="#"
                  @click="setSearchFilter('All Categories')"
                  >All Categories</a
                >
              </li>
              <hr class="dropdown-divider" />
              <li v-for="(searchColumns, index) in columns.search" :key="index">
                <a
                  class="dropdown-item mt-1"
                  href="#"
                  @click="setSearchFilter(searchColumns)"
                  >{{ searchColumns.label }}</a
                >
              </li>
            </ul>
            <form class="search-form" @submit.prevent="performSearch">
              <input
                id="searchBar"
                class="form-control srchip"
                v-model="searchQuery"
                @input="handleInputs"
                type="search"
                placeholder=""
                aria-label="Search"
              />
              <input
                class="btn btn-outline-dark searchbutton"
                type="submit"
                value="Search"
                @click="searchWithQuery()"
              />
            </form>
            <button class="action-icon-btn" @click="clearFilters">
              <!-- <img src="../../assets/icons/clear-filter-icon.svg" alt="filter-icon" class="filter-icon" /> -->
              <svg width="18" height="18" viewBox="0 0 18 18" fill="none">
                <path
                  d="M2 4.5H16M4 9H14M7 13.5H11"
                  stroke="currentColor"
                  stroke-width="1.5"
                  stroke-linecap="round"
                />
              </svg>
            </button>
          </div>
          <!-- New filter button and search form end -->
          <div class="action-buttons">
            <button
              class="action-icon-btn eye-btn"
              @click="toggleGridVisibility"
              data-bs-toggle="tooltip"
              title="Toggle Grid Visibility"
            >
              <i class="fa-solid fa-eye-slash"></i>
            </button>
            <!-- AI button: positioned near download button -->
            <button
              v-if="
                tableProps.type !== 'mapper.MAPPER_MAPPING_JOBS' &&
                tableProps.type !== 'mapper.activities' &&
                tableProps.type === 'mapper.component' &&
                tableProps.type !== 'mapper.Process_Details'
              "
              @click="showAIModal"
              class="action-icon-btn generate-btn"
              title="Generate Prompts"
              :disabled="selectedRows.length === 0"
              :class="{ disabled: selectedRows.length === 0 }"
            >
              <i class="fa-solid fa-comment-nodes"></i>
            </button>
            <!-- AI button: positioned near download button -->
            <!-- <button
              v-if="
                tableProps.type !== 'mapper.MAPPER_MAPPING_JOBS' &&
                tableProps.type !== 'mapper.activities' &&
                tableProps.type === 'mapper.component' &&
                tableProps.type !== 'mapper.Process_Details'
              "
              @click="showOrchestrationModal"
              class="action-icon-btn code-btn"
              title="Orchestration Generation"
              :disabled="selectedRows.length === 0"
              :class="{ disabled: selectedRows.length === 0 }"
            >
              <i class="fa-solid fa-code"></i>
            </button> -->
            <!-- Download button: hide for mapping jobs tab -->
            <button
              v-if="tableProps.type !== 'mapper.MAPPER_MAPPING_JOBS'"
              @click="downloadData"
              class="action-icon-btn download-btn"
            >
              <i class="fas fa-cloud-download fa-sm"></i>
            </button>
            <button
              type="button"
              class="btn btn-primary column-button"
              data-bs-toggle="dropdown"
              :aria-expanded="false"
            >
              <svg
                width="16"
                height="16"
                viewBox="0 0 16 16"
                fill="none"
                style="margin-right: 6px"
              >
                <rect
                  x="2"
                  y="2"
                  width="5"
                  height="5"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="9"
                  y="2"
                  width="5"
                  height="5"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="2"
                  y="9"
                  width="5"
                  height="5"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
                <rect
                  x="9"
                  y="9"
                  width="5"
                  height="5"
                  rx="1"
                  stroke="currentColor"
                  stroke-width="1.5"
                />
              </svg>
              <span>Manage Columns</span>
            </button>
            <ul class="dropdown-menu fade">
              <li>
                <a class="dropdown-item" href="#">
                  <label>
                    <input
                      type="checkbox"
                      :value="'*'"
                      v-model="selectAll"
                      @change="handleSelectAll"
                    />
                    Select All
                  </label>
                </a>
              </li>
              <hr class="dropdown-divider" />
              <li v-for="(column, index) in tableConfigs" :key="index">
                <a class="dropdown-item" href="#">
                  <label>
                    <input
                      type="checkbox"
                      :value="column.name"
                      :disabled="column.checked"
                      v-model="selectedColumns"
                      @change="handleColumnChange(column.name)"
                    />
                    {{ column.label }}
                  </label>
                </a>
              </li>
            </ul>
          </div>
        </div>
        <div class="table-responsive full-height" v-if="tableVisible">
          <!-- Loading overlay: only show if loading and showLoader are true -->
          <div v-if="loading && showLoader">
            <Loading />
          </div>
          <table class="table table-borderless custom-table">
            <thead>
              <tr>
                <!-- Only show checkbox column for Use Cases tab -->
                <th
                  v-if="tableProps.type === 'mapper.component'"
                  class="align-middle table-header-sticky"
                  style="width: 40px; text-align: center"
                >
                  <input
                    type="checkbox"
                    :checked="isAllSelected"
                    @change="toggleSelectAll($event)"
                    class="form-check-input"
                    ref="selectAllCheckbox"
                  />
                </th>
                <th
                  v-for="(header, index) in selectedConfigs"
                  :key="index"
                  scope="col"
                  class="align-middle table-header-sticky"
                  :style="{
                    textAlign:
                      header.headerTextAlign || header.textAlign || 'center',
                    minWidth: header.name === 'process' ? '210px' : undefined, // Increase width for process column
                  }"
                  @mouseover="hoveredColumn = index"
                  @mouseleave="hoveredColumn = ''"
                  @click="
                    header.isSortable && sort(header.name, header.label, index)
                  "
                >
                  <div>
                    {{ header.label }}
                  </div>
                  <div
                    v-if="
                      header.isSortable &&
                      (hoveredColumn === index || sortColumn === index)
                    "
                    class="sort-buttons"
                  >
                    <button class="svg-button" v-if="isDescending">
                      <svg
                        class="svg-icon"
                        style="
                          width: 1em;
                          height: 1em;
                          vertical-align: middle;
                          fill: currentColor;
                          overflow: hidden;
                        "
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M573.056 752l308.8-404.608A76.8 76.8 0 0 0 820.736 224H203.232a76.8 76.8 0 0 0-61.056 123.392l308.8 404.608a76.8 76.8 0 0 0 122.08 0z"
                        />
                      </svg>
                    </button>
                    <button class="svg-button" v-if="!isDescending">
                      <svg
                        class="svg-icon"
                        style="
                          width: 1em;
                          height: 1em;
                          vertical-align: middle;
                          fill: currentColor;
                          overflow: hidden;
                        "
                        viewBox="0 0 1024 1024"
                        version="1.1"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path
                          d="M573.056 272l308.8 404.608A76.8 76.8 0 0 1 820.736 800H203.232a76.8 76.8 0 0 1-61.056-123.392L450.976 272a76.8 76.8 0 0 1 122.08 0z"
                        />
                      </svg>
                    </button>
                  </div>
                </th>
              </tr>
            </thead>
            <tbody>
                   <tr v-if="noRecordFound">
              <td
                class="no-records"
                :colspan="
                  selectedConfigs.length + (isMultiSelectionAllowed ? 1 : 0)
                "
              >
                <div class="no-records-content">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <circle
                      cx="24"
                      cy="24"
                      r="20"
                      stroke="#E4E7EC"
                      stroke-width="2"
                    />
                    <path
                      d="M24 14V26M24 32V34"
                      stroke="#98A2B3"
                      stroke-width="2"
                      stroke-linecap="round"
                    />
                  </svg>
                  <p>No records found</p>
                </div>
              </td>
            </tr>

              <template v-else>
                <template
                  v-for="(transaction, transactionIndex) in reportTransactions"
                  :key="getUniqueIDValue(transaction)"
                >
                  <tr class="table-row">
                    <!-- Only show checkbox column for Use Cases tab -->
                    <td
                      v-if="tableProps.type === 'mapper.component'"
                      class="align-middle"
                      style="text-align: center"
                    >
                      <input
                        type="checkbox"
                        :checked="
                          selectedRows.includes(getUniqueIDValue(transaction))
                        "
                        @change="handleRowSelect($event, transaction)"
                        class="form-check-input"
                      />
                    </td>
                    <td
                      v-for="column in selectedConfigs"
                      :key="column.name"
                      :style="getTextAlignmentStyle(transaction, column)"
                      class="align-middle"
                    >
                      <!-- Dropdown icon for Use Case and Process columns only in Process Details tab -->
                      <template
                        v-if="
                          column.name === 'process' &&
                          tableProps.type === 'mapper.Process_Details'
                        "
                      >
                        <div
                          style="
                            display: flex;
                            align-items: center;
                            position: relative;
                          "
                        >
                          <span
                            v-if="column.name === 'process'"
                            class="btn-mermaid"
                            @click="fetchGraphData(transaction)"
                            style="font-size: inherit; cursor: pointer"
                          >
                            <template
                              v-if="
                                shouldTruncate(
                                  column.label,
                                  getTableData(transaction, column),
                                  25
                                )
                              "
                            >
                              {{
                                truncateText(
                                  getTableData(transaction, column),
                                  25
                                )
                              }}
                              <a
                                v-if="
                                  getTableData(transaction, column) &&
                                  getTableData(transaction, column).length > 25
                                "
                                href="#"
                                @mouseover="
                                  showPopover(
                                    $event,
                                    getTableData(transaction, column)
                                  )
                                "
                                @mouseleave="hidePopover"
                                style="font-size: inherit"
                                >...</a
                              >
                            </template>
                            <template v-else>
                              {{ getTableData(transaction, column) }}
                            </template>
                          </span>
                          <div class="expand-icon-fixed">
                            <button
                              class="btn btn-link p-0"
                              type="button"
                              @click="toggleChildTable(transactionIndex)"
                              aria-expanded="false"
                              style="box-shadow: none"
                            >
                              <!-- Collapse/Expand SVG icon (chevron down) -->
                              <i
                                :class="
                                  openChildTableIndex === transactionIndex
                                    ? 'fa-sharp fa-solid fa-square-minus'
                                    : 'fa-sharp fa-solid fa-square-plus'
                                "
                              ></i>
                            </button>
                          </div>
                        </div>
                      </template>
                      <!-- Action column: add download button -->
                      <template v-else-if="column.name === 'action'">
                        <button
                          class="btn btn-download"
                          @click="childDownloadRowData(transaction)"
                          title="Request Download"
                        >
                          <i class="fas fa-cloud-download fa-lg"></i>
                        </button>
                      </template>
                      <!-- Existing logic for other columns -->
                      <template v-else>
                        <!-- Show only date for Completed Date and Requested Date -->
                        <template
                          v-if="
                            column.name === 'completedDate' ||
                            column.name === 'requestedDate'
                          "
                        >
                          <span style="font-size: inherit">
                            {{
                              formatDateOnly(getTableData(transaction, column))
                            }}
                          </span>
                        </template>
                        <template v-else>
                          <div
                            v-if="
                              shouldTruncate(
                                column.label,
                                getTableData(transaction, column)
                              )
                            "
                          >
                            <span
                              v-if="
                                (tableProps.type === 'mapper.component' ||
                                  tableProps.type ===
                                    'mapper.Process_Details') &&
                                column.name === 'process'
                              "
                              @click="fetchGraphData(transaction)"
                              class="btn-mermaid"
                            >
                              {{
                                truncateText(
                                  getTableData(transaction, column),
                                  25
                                )
                              }}
                            </span>
                            <span v-else style="font-size: inherit">
                              {{
                                truncateText(
                                  getTableData(transaction, column),
                                  25
                                )
                              }}
                            </span>
                            <a
                              href="#"
                              @mouseover="
                                showPopover(
                                  $event,
                                  getTableData(transaction, column)
                                )
                              "
                              @mouseleave="hidePopover"
                              style="font-size: inherit"
                              >...</a
                            >
                          </div>
                          <div v-else>
                            <span
                              v-if="
                                (tableProps.type === 'mapper.component' ||
                                  tableProps.type ===
                                    'mapper.Process_Details') &&
                                column.name === 'process'
                              "
                              @click="fetchGraphData(transaction)"
                              class="btn-mermaid"
                            >
                              {{ getTableData(transaction, column) }}
                            </span>
                            <span v-else style="font-size: inherit">
                              {{ getTableData(transaction, column) }}
                            </span>
                          </div>
                        </template>
                      </template>
                    </td>
                  </tr>
                  <tr v-if="openChildTableIndex === transactionIndex">
                    <td
                      :colspan="
                        tableProps.type === 'mapper.component'
                          ? selectedConfigs.length + 1
                          : selectedConfigs.length
                      "
                      style="padding: 0; background: #f9f9f9"
                    >
                      <!-- Pass collapsed prop and listen for collapse event -->
                      <ChildActivities
                        ref="childActivities"
                        :key="
                          (transaction.process && transaction.process.activities
                            ? transaction.process.activities.length
                            : 0) +
                          '-' +
                          openChildTableIndex
                        "
                        :activities="
                          Array.isArray(
                            transaction.process &&
                              transaction.process.activities
                          )
                            ? transaction.process.activities
                            : []
                        "
                        :collapsed="openChildTableIndex !== transactionIndex"
                        @collapse="handleChildCollapse"
                      />
                      <!-- Debug log -->
                      <span style="display: none">{{
                        console.log(
                          "ChildActivities activities:",
                          transaction.process && transaction.process.activities
                        )
                      }}</span>
                    </td>
                  </tr>
                </template>
              </template>
            </tbody>
          </table>
        </div>
        <div class="pagination-bar" v-if="!noRecordFound">
          <Pagination
            :totalPages="totalPages"
            :perPage="pageSize"
            :currentPage="currentPage"
            :totalRecords="totalRecords"
            @pagechanged="onPageChange"
            @recordCount="onRecordChange"
          />
        </div>
      </div>
    </div>

    <!-- AI Code Generation Modal -->
    <div v-if="showAIPopup" class="modal-overlay" @click="closeAIModal">
      <div class="ai-modal-content" @click.stop>
        <div class="modal-header">
          <h3>AI Prompt Generation</h3>
          <button class="close-button" @click="closeAIModal">&times;</button>
        </div>
        <div class="modal-body">
          <!-- <p>Generate code for selected use cases using AI.</p> -->

          <!-- <div class="selected-items">
            <h4>Selected Items: {{ selectedRows.length }}</h4>
            <div v-if="selectedRows.length === 0" class="no-selection">
              <p class="warning-text">⚠️ Please select at least one row to generate code.</p>
            </div>
            <div v-else class="selection-list">
              <ul>
                <li v-for="rowId in selectedRows.slice(0, 5)" :key="rowId">
                  {{ getRowDisplayName(rowId) }}
                </li>
                <li v-if="selectedRows.length > 5" class="more-items">
                  ... and {{ selectedRows.length - 5 }} more items
                </li>
              </ul>
            </div>
          </div> -->

          <div class="options-section">
            <!-- <h4>Options:</h4> -->
            <div class="checkbox-group">
              <label>
                <input type="checkbox" v-model="aiOptions.isAvroRequired" />
                Include Avro Schema
              </label>
            </div>
          </div>

          <!-- Language Selection Section -->
          <div class="options-section">
            <div class="radio-group">
              <h4>Language</h4>
              <label class="radio-label">
                <input
                  type="radio"
                  name="language"
                  value="Python"
                  v-model="aiOptions.language"
                />
                <span class="radio-text">Python</span>
              </label>
              <label class="radio-label disabled">
                <input
                  type="radio"
                  name="language"
                  value="Java"
                  v-model="aiOptions.language"
                  disabled
                />
                <span class="radio-text">Java</span>
              </label>
              <label class="radio-label disabled">
                <input
                  type="radio"
                  name="language"
                  value="C#"
                  v-model="aiOptions.language"
                  disabled
                />
                <span class="radio-text">C#</span>
              </label>
            </div>
          </div>

          <!-- AI Engine Selection Section -->
          <div class="options-section">
            <div class="radio-group">
              <h4>LLM</h4>
              <label class="radio-label">
                <input
                  type="radio"
                  name="aiEngine"
                  value="Claude Sonnet 4"
                  v-model="aiOptions.aiEngine"
                />
                <span class="radio-text">Claude Sonnet 4</span>
              </label>
              <label class="radio-label disabled">
                <input
                  type="radio"
                  name="aiEngine"
                  value="ChatGPT 4.1"
                  v-model="aiOptions.aiEngine"
                  disabled
                />
                <span class="radio-text">ChatGPT 4.1</span>
              </label>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeAIModal">Cancel</button>
          <button
            class="btn-generate"
            @click="generateCode"
            :disabled="selectedRows.length === 0"
            :class="{ disabled: selectedRows.length === 0 }"
          >
            Generate Prompts
          </button>
        </div>
      </div>
    </div>

    <!-- Orchestration Code Generation Modal -->
    <div
      v-if="showOrchestrationPopup"
      class="modal-overlay"
      @click="closeOrchestrationModal"
    >
      <div class="ai-modal-content" @click.stop>
        <div class="modal-header">
          <h3>Orchestration Generation</h3>
          <button class="close-button" @click="closeOrchestrationModal">
            &times;
          </button>
        </div>
        <div class="modal-body">
          <!-- Language Selection Section - Only Java enabled -->
          <div class="options-section">
            <div class="radio-group">
              <h4>Language</h4>
              <label class="radio-label">
                <input
                  type="radio"
                  name="orchestrationLanguage"
                  value="java"
                  v-model="orchestrationOptions.language"
                />
                <span class="radio-text">Java</span>
              </label>
              <label class="radio-label disabled">
                <input
                  type="radio"
                  name="orchestrationLanguage"
                  value="Python"
                  v-model="orchestrationOptions.language"
                  disabled
                />
                <span class="radio-text">Python</span>
              </label>
              <label class="radio-label disabled">
                <input
                  type="radio"
                  name="orchestrationLanguage"
                  value="C#"
                  v-model="orchestrationOptions.language"
                  disabled
                />
                <span class="radio-text">C#</span>
              </label>
            </div>
          </div>

          <!-- Questions Table -->
          <div class="questions-section">
            <table class="questions-table">
              <tbody>
                <tr>
                  <td>
                    Would you like to migrate EMS/JMS to Kafka ?<br />
                    <small style="color: #666; font-style: italic"
                      >(Selecting "No" will convert TIBCO EMS → Java EMS and
                      TIBCO JMS → Java JMS)</small
                    >
                  </td>
                  <td>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input
                          type="radio"
                          name="migrateEmsJms"
                          value="Yes"
                          v-model="orchestrationOptions.migrateEmsJms"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-option">
                        <input
                          type="radio"
                          name="migrateEmsJms"
                          value="No"
                          v-model="orchestrationOptions.migrateEmsJms"
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>Would you like to include AVRO Schema ?</td>
                  <td>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input
                          type="radio"
                          name="includeAvroSchema"
                          value="Yes"
                          v-model="orchestrationOptions.includeAvroSchema"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-option">
                        <input
                          type="radio"
                          name="includeAvroSchema"
                          value="No"
                          v-model="orchestrationOptions.includeAvroSchema"
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    Would you like to migrate SOAP APIs to REST ?<br />
                    <small style="color: #666; font-style: italic"
                      >(Selecting "No" will convert TIBCO SOAP APIs to
                      Java-based SOAP APIs)</small
                    >
                  </td>
                  <td>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input
                          type="radio"
                          name="migrateSoapToRest"
                          value="Yes"
                          v-model="orchestrationOptions.migrateSoapToRest"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-option">
                        <input
                          type="radio"
                          name="migrateSoapToRest"
                          value="No"
                          v-model="orchestrationOptions.migrateSoapToRest"
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </td>
                </tr>
                <tr>
                  <td>
                    Would you like to persist workflow history and metrics?
                  </td>
                  <td>
                    <div class="radio-options">
                      <label class="radio-option">
                        <input
                          type="radio"
                          name="persistWorkflowHistory"
                          value="Yes"
                          v-model="orchestrationOptions.persistWorkflowHistory"
                        />
                        <span>Yes</span>
                      </label>
                      <label class="radio-option">
                        <input
                          type="radio"
                          name="persistWorkflowHistory"
                          value="No"
                          v-model="orchestrationOptions.persistWorkflowHistory"
                        />
                        <span>No</span>
                      </label>
                    </div>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
        <div class="modal-footer">
          <button class="btn-cancel" @click="closeOrchestrationModal">
            Cancel
          </button>
          <button
            class="btn-generate"
            @click="generateOrchestrationCode"
            :disabled="selectedRows.length === 0"
            :class="{ disabled: selectedRows.length === 0 }"
          >
            Generate Code
          </button>
        </div>
      </div>
    </div>

    <FooterView />
  </div>
</template>

<script>
import { getCookie } from "../../store/cookie.js";
import { makeOpearationRequest } from "@/services/apiServices";
import Pagination from "../Pagination.vue";
import { user } from "../../utils/util.js";
import { changeFileExtension, formatDateConsistent } from "@/utils/util.js";
import { toast } from "vue3-toastify";
import { Popover } from "bootstrap";
import Loading from "../Loading.vue";
import FooterView from "@/views/FooterView.vue";
import ChildActivities from "@/views/ChildActivities.vue";

export default {
  name: "ViewTemplate",
  props: ["tableProps", "projectParamId", "mapperParamId"],
  data() {
    return {
      selectedConfigs: {},
      loading: false,
      showLoader: true,
      selectedRows: [],
      tableConfigs: this.tableProps.configs,
      selectedColumns: this.tableProps.configs
        .filter((column) => column.defaultSelected)
        .map((column) => column.name),
      selectAll: false, // will be set in mounted
      currentPage: 1,
      pageSize: 20,
      totalPages: 5,
      reportTransactions: [],
      totalRecords: 0,
      noRecordFound: false,
      sortColumn: this.getDefaultSortColumnIndex(),
      filterSortColumn: this.tableProps.defaultSortColumn || {
        name: "defaultColumn",
      }, // Def
      filterSortOrder: this.tableProps.defaultSortOrder || { name: "asc" }, // Default sort order
      tableVisible: true,
      hoveredColumn: "",
      isDescending: true,
      searchConcept: "All Categories",
      searchQuery: "",
      columns: {
        default: {},
        sort: {},
        search: {},
      },
      showModal: false,
      modalTitle: "",
      modalContent: "",
      openChildTableIndex: null, // <-- track which parent row is open
      selectedChildRows: [],
      childActivitiesCache: {}, // cache for child activities by processId
      showAIPopup: false, // AI modal visibility
      aiOptions: {
        isAvroRequired: false,
        language: "Python",
        aiEngine: "Claude Sonnet 4",
      },
      showOrchestrationPopup: false, // Orchestration modal visibility
      orchestrationOptions: {
        language: "java",
        migrateEmsJms: "No",
        includeAvroSchema: "No",
        migrateSoapToRest: "No",
        persistWorkflowHistory: "No",
      },
    };
  },
  inject: ["toggleMapperTabs"],
  components: {
    Pagination,
    Loading,
    FooterView,
    ChildActivities,
  },
  async mounted() {
    this.refresh();
    this.updateSelectedConfigs();
    this.view();
    this.columns.search = this.tableConfigs
      .filter((item) => item.search != false)
      .map(({ name, label }) => ({ name, label }));
    // Set selectAll if all columns are selected by default
    this.selectAll = this.selectedColumns.length === this.tableConfigs.length;
  },
  computed: {
    allRowIds() {
      return this.reportTransactions.map((transaction) =>
        this.getUniqueIDValue(transaction)
      );
    },
    isAllSelected: {
      get() {
        // Only calculate for Use Cases tab
        if (this.tableProps.type !== "mapper.component") {
          return false;
        }
        return (
          this.reportTransactions.length > 0 &&
          this.selectedRows.length === this.reportTransactions.length
        );
      },
      set(value) {
        // Only allow selection for Use Cases tab
        if (this.tableProps.type !== "mapper.component") {
          return;
        }
        if (value) {
          this.selectedRows = [...this.allRowIds];
        } else {
          this.selectedRows = [];
        }
      },
    },
  },
  methods: {
    toggleSelectAll(event) {
      // Only allow for Use Cases tab
      if (this.tableProps.type !== "mapper.component") {
        return;
      }
      if (event.target.checked) {
        this.selectedRows = [...this.allRowIds];
      } else {
        this.selectedRows = [];
      }
    },
    handleRowSelect(event, transaction) {
      // Only allow for Use Cases tab
      if (this.tableProps.type !== "mapper.component") {
        return;
      }
      const rowId = this.getUniqueIDValue(transaction);
      console.log("Row selection changed:", {
        rowId,
        checked: event.target.checked,
        currentSelection: this.selectedRows,
      });

      if (event.target.checked) {
        // Add to selection if not already selected
        if (!this.selectedRows.includes(rowId)) {
          this.selectedRows = [...this.selectedRows, rowId];
          console.log("Added to selection. New selection:", this.selectedRows);
        }
      } else {
        // Remove from selection
        this.selectedRows = this.selectedRows.filter((id) => id !== rowId);
        console.log(
          "Removed from selection. New selection:",
          this.selectedRows
        );
      }
    },
    async view() {
      this.loading = true;
      // Only show loader if showLoader is true (showLoader is set to true for non-sort actions)
      let searchValues = { queryValue: this.searchQuery.trim() };
      if (this.searchName != "") {
        searchValues = { ...searchValues, ...{ queryColumn: this.searchName } };
      }
      const sortField =
        this.tableProps.type === "mapper.MAPPER_MAPPING_JOBS"
          ? "requestedDate"
          : this.tableProps.type !== "mapper.usage" &&
            this.tableProps.type !== "mapper.activities" &&
            this.tableProps.type !== "mapper.component" &&
            this.tableProps.type !== "mapper.Process_Details"
          ? this.filterSortColumn.name.toLowerCase() === "usecase"
            ? "usecase"
            : this.filterSortColumn.name.toLowerCase() === "process"
            ? "usecase,process"
            : `usecase,process,${this.filterSortColumn.name}`
          : this.filterSortColumn.name;
      let payload = {
        userId: getCookie(user.id),
        type: this.tableProps.type,
        requestId: this.projectParamId,
        mapperId: this.mapperParamId,
        sort: {
          field: sortField,
          order: this.filterSortOrder.name,
        },
        pagination: {
          page: this.currentPage,
          pageSize: this.pageSize,
        },
      };
      if (searchValues != null) {
        payload = { ...payload, ...searchValues };
      }
      try {
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/view",
          payload
        );
        if (response.status === 200) {
          this.reportTransactions = response.data.transactions;
          console.log("Report transactions:", this.reportTransactions);
          this.noRecordFound = this.reportTransactions.length === 0;
          this.totalRecords = response.data.totalRecords;
          console.log("Response data:", response.data);
          this.totalPages = Math.ceil(
            response.data.totalRecords / this.pageSize
          );
        } else {
          this.noRecordFound = false;
        }
      } catch (error) {
        console.error("Failed to fetch data:", error);
        this.noRecordFound = true;
      } finally {
        this.loading = false;
        this.showLoader = false; // reset after each view
      }
    },
    toggleGridVisibility() {
      this.toggleMapperTabs();
    },
    handleSelectAll() {
      if (this.selectAll) {
        this.selectedColumns = this.tableConfigs.map((column) => column.name);
      } else {
        this.selectedColumns = this.tableConfigs
          .filter((column) => column.defaultSelected)
          .map((column) => column.name);
      }
      this.updateSelectedConfigs();
      this.view();
    },
    handleColumnChange(value) {
      this.selectAll = this.selectedColumns.length === this.tableConfigs.length;
      this.updateSelectedConfigs();
      this.view();
    },
    updateSelectedConfigs() {
      this.selectedConfigs = this.tableConfigs.filter((column) =>
        this.selectedColumns.includes(column.name)
      );
    },
    getUniqueIDValue(transaction) {
      // Define one primary ID field and search case-insensitively
      const primaryIdField = "id";

      // First, try to find the primary ID field (case-insensitive)
      const keys = Object.keys(transaction);
      const idKey = keys.find(
        (key) => key.toLowerCase() === primaryIdField.toLowerCase()
      );

      if (idKey && transaction[idKey] !== undefined) {
        return transaction[idKey];
      }

      // Fallback: try other common ID fields (case-insensitive)
      const fallbackIdFields = ["requestId", "transactionId"];
      for (const field of fallbackIdFields) {
        const foundKey = keys.find(
          (key) => key.toLowerCase() === field.toLowerCase()
        );
        if (foundKey && transaction[foundKey] !== undefined) {
          return transaction[foundKey];
        }
      }

      // If no ID field found, create a unique key from multiple fields as a fallback
      if (transaction) {
        return JSON.stringify(transaction);
      }

      // Last resort fallback
      return Math.random().toString(36).substr(2, 9);
    },
    async showAIModal() {
      // Check if any rows are selected
      if (this.selectedRows.length === 0) {
        toast.error("Please select at least one row to Generate Prompts.", {
          autoClose: 3000,
        });
        return;
      }

      // Call the usecase_ai_enable API when button is clicked
      try {
        const payload = {
          userId: getCookie(user.id),
          projectid: this.projectParamId,
          type: "MAPPER.USECASE_AI_ENABLE",
        };

        console.log("Checking AI enablement with payload:", payload);

        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/usecase_ai_enable",
          payload
        );

        if (response.status === 200) {
          // Check if AI is enabled based on the API response
          const isAIEnabledForProject =
            response.data.xsl_status === "ok" &&
            response.data.schema_status === "ok" &&
            response.data.mapper_status === "ok";
          console.log("AI enablement status:", isAIEnabledForProject);

          if (!isAIEnabledForProject) {
            toast.error("AI functionality is not enabled for this project.", {
              autoClose: 3000,
            });
            return;
          }

          // If AI is enabled, show the modal
          this.showAIPopup = true;
        } else {
          toast.error("Failed to check AI enablement. Please try again.", {
            autoClose: 3000,
          });
          console.warn("AI enablement check failed:", response);
        }
      } catch (error) {
        console.error("Error checking AI enablement:", error);
        toast.error("An error occurred while checking AI enablement.", {
          autoClose: 3000,
        });
      }
    },
    async showOrchestrationModal() {
      // Check if any rows are selected
      try {
        const payload = {
          userId: getCookie(user.id),
          projectid: this.projectParamId,
          type: "MAPPER.USECASE_AI_ENABLE",
        };

        console.log("Checking Orchestration enablement with payload:", payload);

        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/usecase_ai_enable",
          payload
        );

        if (response.status === 200) {
          // Check if orchestration is enabled based on the API response
          const isOrchestrationEnabledForProject =
            response.data.xsl_status === "ok" &&
            (response.data.schema_status === "ok" ||
              response.data.schema_status === "NA") &&
            response.data.mapper_status === "ok";
          console.log(
            "Orchestration enablement status:",
            isOrchestrationEnabledForProject
          );

          if (!isOrchestrationEnabledForProject) {
            // Show toast with actual status values
            const { xsl_status, schema_status, mapper_status } = response.data;
            toast.error(
              `Orchestration status:\nXSL: ${xsl_status}\nSchema: ${schema_status}\nMapper: ${mapper_status}`,
              {
                autoClose: 4000,
              }
            );
            return;
          }

          // If orchestration is enabled, show the orchestration modal
          this.showOrchestrationPopup = true;
        } else {
          toast.error(
            "Failed to check Orchestration enablement. Please try again.",
            {
              autoClose: 3000,
            }
          );
          console.warn("Orchestration enablement check failed:", response);
        }
      } catch (error) {
        console.error("Error checking Orchestration enablement:", error);
        toast.error(
          "An error occurred while checking Orchestration enablement.",
          {
            autoClose: 3000,
          }
        );
      }
    },
    closeAIModal() {
      this.showAIPopup = false;
    },
    async generateOrchestrationCode() {
      let toastId = null;
      try {
        toastId = toast.loading("Generating orchestration...");
        const usecasesIds = this.selectedRows.map((rowId) => {
          const transaction = this.reportTransactions.find(
            (trans) => this.getUniqueIDValue(trans) === rowId
          );
          return (
            transaction?.usecaseIds ||
            transaction?.usecaseId ||
            transaction?.useCase ||
            transaction?.id ||
            rowId
          );
        });
        const payload = {
          userId: getCookie(user.id),
          usecasesIds: usecasesIds,
          type: "ORCHESTRATION.GENERATE_CODE",
          additional_input: {
            language: this.orchestrationOptions.language,
            migrate_ems_jms_to_kafka:
              this.orchestrationOptions.migrateEmsJms === "Yes",
            include_avro_schema:
              this.orchestrationOptions.includeAvroSchema === "Yes",
            migrate_soap_to_rest:
              this.orchestrationOptions.migrateSoapToRest === "Yes",
            persist_workflow_history:
              this.orchestrationOptions.persistWorkflowHistory === "Yes",
          },
        };
        console.log("Generating orchestration with payload:", payload);
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/generate_orchestration",
          payload
        );
        if (response.status === 200) {
          toast.update(toastId, {
            render: "Orchestration generated successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });
          console.log("Orchestration generation successful:", response.data);
        } else {
          toast.update(toastId, {
            render: "Failed to generate orchestration. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          console.warn("Orchestration generation failed:", response);
        }
        this.closeOrchestrationModal();
      } catch (error) {
        console.error("Error generating orchestration:", error);
        if (toastId) {
          toast.update(toastId, {
            render: "An error occurred while generating orchestration.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.error("An error occurred while generating orchestration.", {
            autoClose: 3000,
          });
        }
        this.closeOrchestrationModal();
      }
    },
    closeOrchestrationModal() {
      this.showOrchestrationPopup = false;
    },
    getRowDisplayName(rowId) {
      // Find the transaction by ID and return a display name
      const transaction = this.reportTransactions.find(
        (trans) => this.getUniqueIDValue(trans) === rowId
      );

      if (transaction) {
        // Try to get a meaningful display name from common fields
        return (
          transaction.name ||
          transaction.processName ||
          transaction.useCase ||
          transaction.process ||
          transaction.title ||
          `Item ${rowId}`
        );
      }
      return `Item ${rowId}`;
    },
    async generateCode() {
      // Check if any rows are selected
      if (this.selectedRows.length === 0) {
        toast.error("Please select at least one row to Generate Prompts.", {
          autoClose: 3000,
        });
        return;
      }

      // Close the modal
      this.closeAIModal();

      let toastId = null;
      try {
        // Show loading toast
        toastId = toast.loading("Generating prompts...");
        // Get the selected usecase IDs from selected rows
        const usecasesIds = this.selectedRows.map((rowId) => {
          // Find the transaction by ID and extract usecase ID
          const transaction = this.reportTransactions.find(
            (trans) => this.getUniqueIDValue(trans) === rowId
          );
          // You may need to adjust this based on your data structure
          // Common field names for usecase ID: 'usecaseIds', 'usecaseId', 'useCase', 'id'
          return (
            transaction?.usecaseIds ||
            transaction?.usecaseId ||
            transaction?.useCase ||
            transaction?.id ||
            rowId
          );
        });

        const payload = {
          userId: getCookie(user.id),
          usecasesIds: usecasesIds,
          type: "MAPPER.GENERATIVE_CODE",
          additional_input: {
            isAvroRequired: this.aiOptions.isAvroRequired,
            language: this.aiOptions.language.toLowerCase(),
            aiEngine: this.getSimplifiedAiEngine(),
          },
        };

        // Configure for blob response (file download)
        const config = {
          responseType: "blob",
        };

        console.log("Generating prompts with payload:", payload);

        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/generative_code",
          payload,
          config
        );

        if (response.status === 200) {
          toast.update(toastId, {
            render: "Prompts generated and downloaded successfully!",
            type: "success",
            isLoading: false,
            autoClose: 3000,
          });

          // Handle the blob response like other download functions
          const blob = new Blob([response.data], { type: response.data.type });

          // Retrieve the fileName from response headers
          let fileName = "generated_prompts";
          const contentDisposition = response.headers["content-disposition"];
          if (contentDisposition) {
            const fileNameMatch = contentDisposition.match(/filename="?(.+)"?/);
            if (fileNameMatch && fileNameMatch.length > 1) {
              fileName = fileNameMatch[1];
            }
          }

          // Create a link element and trigger the download
          const url = window.URL.createObjectURL(blob);
          const a = document.createElement("a");
          a.href = url;
          a.download = changeFileExtension(fileName, "zip");
          document.body.appendChild(a);
          a.click();
          document.body.removeChild(a);
          window.URL.revokeObjectURL(url);
        } else {
          toast.update(toastId, {
            render: "Failed to Generate Prompts. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          console.error("Failed to Generate Prompts:", response);
        }
      } catch (error) {
        console.error("Error generating prompts:", error);
        if (toastId) {
          toast.update(toastId, {
            render: "An error occurred while generating prompts.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.error("An error occurred while generating prompts.", {
            autoClose: 3000,
          });
        }
      }
    },
    getTextAlignmentStyle(transaction, column) {
      // Return an object instead of a string
      if (column.textAlign) {
        return { textAlign: column.textAlign };
      } else {
        return { textAlign: "center" };
      }
    },
    getStylesForStatus(transaction, column, isActionable) {
      return "";
    },
    getTableData(transaction, column) {
      return transaction[column.label];
    },
    refresh() {
      this.showLoader = true; // show loader for non-sort actions
      this.loading = true;
    },
    onPageChange(page) {
      this.currentPage = page;
      this.showLoader = true; // show loader for pagination
      this.refresh();
      this.view();
    },
    onRecordChange(recordSize) {
      this.pageSize = recordSize;
      this.showLoader = true; // show loader for record size change
      this.refresh();
      this.view();
    },
    async downloadData() {
      let toastId = null;

      try {
        // Show loading toast
        toastId = toast.loading("Processing download request...", {
          closeOnClick: false,
        });

        let payload = {
          userId: getCookie(user.id),
          type: this.tableProps.type,
          requestIds: [this.projectParamId],
        };

        const initialResponse = await makeOpearationRequest(
          this.$acclConfigs,
          "/download",
          payload
        );

        if (initialResponse.status === 200 || initialResponse.status === 202) {
          const contentType = initialResponse.headers["content-type"];

          if (contentType && contentType.includes("application/json")) {
            const responseData = initialResponse.data;

            if (responseData.download_id && responseData.status === "new") {
              toast.update(toastId, {
                render: `${responseData.message}`,
                type: "info",
                isLoading: false,
                autoClose: 5000,
              });
            } else {
              toast.update(toastId, {
                render: responseData.message || "Download request processed.",
                type: "info",
                isLoading: false,
                autoClose: 4000,
              });
            }
          } else {
            const blobConfig = {
              responseType: "blob",
            };

            const blobResponse = await makeOpearationRequest(
              this.$acclConfigs,
              "/download",
              payload,
              blobConfig
            );

            if (blobResponse.status === 200) {
              toast.update(toastId, {
                render: "File downloaded successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
              });

              const blob = new Blob([blobResponse.data], {
                type: blobResponse.data.type,
              });
              let fileName = "downloaded_file";
              const contentDisposition =
                blobResponse.headers["content-disposition"];
              if (contentDisposition) {
                const fileNameMatch =
                  contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch && fileNameMatch.length > 1) {
                  fileName = fileNameMatch[1];
                }
              }
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = changeFileExtension(fileName, "zip");
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            } else {
              toast.update(toastId, {
                render: "Download failed. Please try again.",
                type: "error",
                isLoading: false,
                autoClose: 3000,
              });
            }
          }
        } else {
          toast.update(toastId, {
            render: "Download failed. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          console.error("Failed to fetch data:", initialResponse);
        }
      } catch (error) {
        if (toastId) {
          toast.update(toastId, {
            render: "Download request failed. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.error("Download request failed. Please try again.", {
            autoClose: 3000,
          });
        }
        console.error("Failed to fetch data:", error);
      }
    },
    convertToCSV(data) {
      const headers = this.selectedConfigs
        .map((config) => config.label)
        .join(",");
      const rows = data
        .map((row) => {
          return this.selectedConfigs
            .map((config) => {
              const value = row[config.label];
              if (typeof value === "object" && value !== null) {
                return JSON.stringify(value);
              }
              return value;
            })
            .join(",");
        })
        .join("\n");
      return `${headers}\n${rows}`;
    },
    sort(name, label, index) {
      // Do NOT show loader for sorting
      if (this.isDescending) {
        this.sortAscending(name, label, index);
      } else {
        this.sortDescending(name, label, index);
      }
    },
    sortAscending(name, label, index) {
      this.sortColumn = index;
      this.isDescending = false;
      this.updateFilterSortOrder("asc", "Ascending");
      this.handleSortByChange(name, false); // false = don't show loader
    },
    sortDescending(name, label, index) {
      this.sortColumn = index;
      this.isDescending = true;
      this.updateFilterSortOrder("desc", "Descending");
      this.handleSortByChange(name, false); // false = don't show loader
    },
    handleSortByChange(name, showLoader = false) {
      this.filterSortColumn.name = name;
      this.showLoader = showLoader; // will be false for sort
      this.view();
    },
    updateFilterSortOrder(name, label) {
      this.filterSortOrder.name = name;
      this.filterSortOrder.label = label;
    },
    getDefaultSortColumnIndex() {
      const defaultSortColumn = this.tableProps.defaultSortColumn;
      if (!defaultSortColumn || !defaultSortColumn.name) {
        return 0;
      }
      const sortColumnName = defaultSortColumn.name;
      const config = this.tableProps.configs.find(
        (item) => item.name === sortColumnName
      );
      return config ? (config.order > 0 ? config.order - 1 : config.order) : 0;
    },
    handleInputs(event) {
      if (!event.target.value) {
        this.view();
      }
    },
    async searchWithQuery() {
      this.currentPage = 1;
      this.showLoader = true; // show loader for search
      await this.view();
    },
    clearFilters() {
      this.searchName = "";
      this.searchConcept = "All Categories";
      this.searchQuery = "";
      this.showLoader = true; // show loader for clear
      this.view();
    },
    clearUpdatedViews() {
      removeSessionItem(this.tableProps.type + "_columns");
      removeSessionItem(this.tableProps.type + "_view_updated");
    },
    setSearchFilter(filter) {
      if (filter == "All Categories") {
        this.searchConcept = filter;
      } else {
        this.searchConcept = filter.label;
      }
      this.searchName = filter.name;
    },
    showPopover(event, content) {
      const popover = new Popover(event.target, {
        content: content,
        trigger: "hover",
        placement: "auto",
        container: "body",
        boundary: "viewport",
        fallbackPlacements: ["top", "bottom", "left", "right"],
      });
      popover.show();
    },
    hidePopover(event) {
      const popover = Popover.getInstance(event.target);
      if (popover) {
        popover.hide();
      }
    },
    shouldTruncate(label, text, minLength = 25) {
      const truncatableLabels = [
        "Use Case Location",
        "Use Case",
        "Process",
        "Process Location",
        "Sub Process",
        "Sub Process Location",
        "Input Node",
        "Binding Node",
        "Condition",
        "Condition Group",
        "Transition From",
        "Transition To",
        "Input",
        "Output",
        "Supporting Process Location",
        "Supporting Process",
        "Field Name",
        "Reference Name",
        "Expression",
        "Reference Field Name",
        "Process Name",
        "Job Name",
      ];
      return (
        truncatableLabels.includes(label) && text && text.length > minLength
      );
    },
    truncateText(text, length) {
      return text.length > length ? text.substring(0, length) : text;
    },
    emitOpenMermaidChart(transaction) {
      const mermaidDiagram = transaction.diagram || transaction.diagramData;
      this.$emit("openMermaidChart", mermaidDiagram);
    },
    async fetchGraphData(transaction) {
      let graphType = "MAPPER.USECASE_GRAPH";
      if (this.tableProps.type === "mapper.Process_Details") {
        graphType = "MAPPER.PROCESS_GRAPH";
      }
      const payload = {
        userId: getCookie(user.id),
        dataId: transaction.id,
        type: graphType,
      };
      try {
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/graph_data",
          payload
        );
        if (response.status === 200) {
          this.$emit("openMermaidChart", response.data);
        } else {
          console.error("Failed to fetch graph data:", response);
        }
      } catch (error) {
        console.error("Error while fetching graph data:", error);
      }
    },

    async fetchChildActivities(processId) {
      // Check cache first
      if (this.childActivitiesCache[processId]) {
        const cached = this.childActivitiesCache[processId];
        return Array.isArray(cached) ? cached : [];
      }

      const payload = {
        userId: getCookie(user.id),
        processId: processId,
        type: "MAPPER.CHILD_ACTIVITIES",
      };

      this.showLoader = true;
      try {
        const response = await makeOpearationRequest(
          this.$acclConfigs,
          "/childActivities",
          payload
        );
        this.showLoader = false;
        // Extract activities array from response.data.data
        let activities = [];
        if (response.status === 200) {
          if (Array.isArray(response.data)) {
            activities = response.data;
          } else if (response.data && Array.isArray(response.data.data)) {
            activities = response.data.data;
          }
        }
        this.childActivitiesCache[processId] = activities;
        return activities;
      } catch (e) {
        console.error("Failed to fetch child activities", e);
        return [];
      }
    },
    async toggleChildTable(index) {
      if (this.openChildTableIndex === index) {
        this.openChildTableIndex = null;
      } else {
        const transaction = this.reportTransactions[index];
        const processId =
          transaction?.process?.id || transaction?.processId || transaction?.id;
        if (processId) {
          const activities = await this.fetchChildActivities(processId);
          if (!transaction.process) transaction.process = {};
          // Always assign an array
          transaction.process.activities = Array.isArray(activities)
            ? activities
            : [];
          if (typeof this.$set === "function") {
            this.$set(this.reportTransactions, index, { ...transaction });
          } else {
            this.reportTransactions = [...this.reportTransactions];
          }
        }
        this.openChildTableIndex = index;
      }
      this.$nextTick(() => {
        const child = this.$refs.childActivities?.[index];
        if (child && typeof child.toggleChildTable === "function")
          child.toggleChildTable();
      });
    },
    handleChildCollapse() {
      this.openChildTableIndex = null;
    },
    async childDownloadRowData(transaction) {
      console.log("Downloading row data for transaction:", transaction);

      let toastId = null;

      try {
        toastId = toast.loading("Processing download request...", {
          closeOnClick: false,
        });

        let payload = {
          userId: getCookie(user.id),
          jobId: transaction["Job Id"], // Use jobId if available, otherwise use transaction id
        };

        const initialResponse = await makeOpearationRequest(
          this.$acclConfigs,
          "/jobdownload",
          payload
        );

        if (initialResponse.status === 200 || initialResponse.status === 202) {
          const contentType = initialResponse.headers["content-type"];

          if (contentType && contentType.includes("application/json")) {
            const responseData = initialResponse.data;

            if (responseData.download_id && responseData.status === "new") {
              toast.update(toastId, {
                render: `Download request accepted! Request ID: ${responseData.download_id}. ${responseData.message}`,
                type: "info",
                isLoading: false,
                autoClose: 5000,
              });
            } else {
              toast.update(toastId, {
                render: responseData.message || "Download request processed.",
                type: "info",
                isLoading: false,
                autoClose: 4000,
              });
            }
          } else {
            const blobConfig = {
              responseType: "blob",
            };

            const blobResponse = await makeOpearationRequest(
              this.$acclConfigs,
              "/jobdownload",
              payload,
              blobConfig
            );

            if (blobResponse.status === 200) {
              toast.update(toastId, {
                render: "Download completed successfully!",
                type: "success",
                isLoading: false,
                autoClose: 3000,
              });

              const blob = new Blob([blobResponse.data], {
                type: blobResponse.data.type,
              });
              let fileName = "downloaded_file";
              const contentDisposition =
                blobResponse.headers["content-disposition"];
              if (contentDisposition) {
                const fileNameMatch =
                  contentDisposition.match(/filename="?(.+)"?/);
                if (fileNameMatch && fileNameMatch.length > 1) {
                  fileName = fileNameMatch[1];
                }
              }
              const url = window.URL.createObjectURL(blob);
              const a = document.createElement("a");
              a.href = url;
              a.download = changeFileExtension(fileName, "zip");
              document.body.appendChild(a);
              a.click();
              document.body.removeChild(a);
              window.URL.revokeObjectURL(url);
            } else {
              toast.update(toastId, {
                render: "Download failed. Please try again.",
                type: "error",
                isLoading: false,
                autoClose: 3000,
              });
            }
          }
        } else {
          toast.update(toastId, {
            render: "Download failed. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
          console.error("Failed to download row data:", initialResponse);
        }
      } catch (error) {
        if (toastId) {
          toast.update(toastId, {
            render: "Download request failed. Please try again.",
            type: "error",
            isLoading: false,
            autoClose: 3000,
          });
        } else {
          toast.error("Download request failed. Please try again.", {
            autoClose: 3000,
          });
        }
        console.error("Failed to download row data:", error);
      }
    },
    formatDateOnly(value) {
      if (!value || value === null) return "-";
      const date = new Date(value);
      if (isNaN(date.getTime())) return value;
      // Use consistent MM/DD/YYYY format across all platforms
      return formatDateConsistent(date);
    },
    getSimplifiedAiEngine() {
      switch (this.aiOptions.aiEngine) {
        case "Claude Sonnet 4":
          return "claude";
        case "ChatGPT 4.1":
          return "chatgpt";
        default:
          return this.aiOptions.aiEngine.toLowerCase();
      }
    },
  },
};
</script>

<style scoped>
/* --- Global & Container Styles --- */
.container-fluid {
  /* Uses the dark theme's background */
  background-color: var(--body-bg);
  color: var(--text-primary);

  /* padding-bottom: 50px; */
  overflow-y: auto;
}

/* --- Header/Toolbar Styles --- */
.d-flex.justify-content-end {
  /* Matches the table surface color for the bar area */
  background-color: var(--surface);
  padding: 10px 15px;
  border-radius: 10px 10px 0 0;
  align-items: center;
}

.col.d-flex.gap-2.justify-content-end.right-margin {
  margin-right: 15px;
  align-items: center;
}

/* --- Primary Buttons (Dropdowns like "All Categories") --- */
.btn-primary.allCategories,
.column-button {
  display: flex;
  align-items: center;
  height: 40px;
  padding: 0 14px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text-primary);
  font-size: 14px;
  font-weight: 500;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
  transition: background-color 0.2s, border-color 0.2s, color 0.2s;
}

.btn-primary.allCategories:hover,
.column-button:hover {
  /* Uses the primary background color for hover effect, which is dark */
  background: var(--surface-hover);
  border-color: var(--text-secondary);
  color: var(--text-primary);
}

/* --- Search Bar & Button --- */
.search-form {
  display: flex;
  align-items: center;
  border: 1px solid var(--border-color);
  border-radius: 5px;
  overflow: hidden;
  background-color: var(--body-bg); /* Darker than surface for input field */
  height: 38px;
}

#searchBar {
  background-color: var(--surface);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  padding: 0.375rem 0.75rem;
  flex-grow: 1;
  min-width: 250px;
  height: 100%;
}

#searchBar::placeholder {
  color: var(--text-secondary);
}

.searchbutton {
  /* Uses surface-hover/active for the 'Search' button */
  background-color: var(--primary);
  color: #fff;
  border: none;
  border-radius: 0;
  padding: 0.375rem 1rem;
  height: 100%;
  cursor: pointer;
  transition: background-color 0.2s;
  font-weight: 500;
}

.searchbutton:hover {
  background-color: var(--surface-active);
  color: var(--text-primary);
}

/* --- Icon Buttons (Cloud, AI, Orchestration, Filter) --- */
.btn-eye,
.btn-ai,
.btn-orchestration,
.download-button,
.clear-filter-icon {
  /* Styled as ghost buttons with text-primary color */
  background: none;
  border: 1px solid var(--border-color);
  color: var(--text-primary);
  width: 38px;
  height: 38px;
  border-radius: 5px;
  display: flex;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  transition: background-color 0.2s, border-color 0.2s;
}

.btn-eye:hover,
.btn-ai:hover,
.btn-orchestration:hover,
.download-button:hover,
.clear-filter-icon:hover {
  background-color: var(--surface-hover);
  border-color: var(--primary); /* Highlight border on hover */
}

.download-button i {
  color: var(--text-primary); /* Icon color */
  font-size: 1.1rem;
}

/* Assuming AI and Orchestration buttons use SVGs/Icons that inherit color */
.btn-ai.disabled,
.btn-orchestration.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  background-color: var(--surface);
  border-color: var(--border-color);
}

/* Filter icon: inverting an SVG to match dark theme light text */
.filter-icon {
  width: 1.25rem;
  height: 1.25rem;
  filter: none; /* Assuming your SVG is correctly colored by currentColor/CSS variables */
  color: var(--text-primary);
}

.action-buttons {
  display: flex;
  gap: 8px;
  align-items: center;
}

.action-icon-btn {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 40px;
  height: 40px;
  border: 1px solid var(--border-color);
  border-radius: 8px;
  background: var(--surface);
  color: var(--text-secondary);
  cursor: pointer;
  transition: all 0.2s;
  font-size: 16px;
}

.action-icon-btn:hover:not(:disabled) {
  background: var(--surface-hover);
  color: var(--text-primary);
  border-color: var(--text-secondary);
}

.action-icon-btn:disabled {
  opacity: 0.4;
  cursor: not-allowed;
}

.action-icon-btn.delete-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--error) 10%, var(--surface));
  color: var(--error);
  border-color: var(--error);
}

.action-icon-btn.download-btn {
  color: var(--download);
  border-color:var(--download);
}

.action-icon-btn.download-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--download) 10%, var(--surface));
  color: var(--download);
  border-color: var(--download);
}

.action-icon-btn.eye-btn {
  color: var(--eye);
  border-color:var(--eye);
}

.action-icon-btn.eye-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--eye) 10%, var(--surface));
  color: var(--eye);
  border-color: var(--eye);
}

.action-icon-btn.generate-btn {
  color: var(--generate);
  border-color:var(--generate);
}

.action-icon-btn.generate-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--generate) 10%, var(--surface));
  color: var(--generate);
  border-color: var(--generate);
}

.action-icon-btn.code-btn {
  color: var(--code);
  border-color:var(--code);
}

.action-icon-btn.code-btn:hover:not(:disabled) {
  background: color-mix(in srgb, var(--code) 10%, var(--surface));
  color: var(--code);
  border-color: var(--code);
}

/* --- Dropdown Menu (All Categories, Columns) --- */
.dropdown-menu {
  background-color: var(--surface);
  border: 1px solid var(--border-color);
  box-shadow: 0 4px 6px var(--shadow-strong);
  overflow: auto;
  height: calc(100vh - 400px);
}

.dropdown-menu li a {
  color: var(--dropdown-text); /* White in dark mode */
  padding: 0.5rem 1rem;
  transition: background-color 0.1s;
}

.dropdown-menu li a:hover {
  background-color: var(--surface-hover);
  color: var(--text-primary);
}

.dropdown-divider {
  border-top: 1px solid var(--border-color);
  margin: 0;
}

/* --- Table Styles (Core Data Grid) --- */
.table-responsive {
  width: 100%;
  height: calc(100vh - 450px);
  overflow: auto;
}

.table-responsive table {
  width: 100%;
  border-collapse: collapse;
  table-layout: auto;
  max-width: 100%;
  word-wrap: break-word;
}

.table-row:hover {
  background-color: #000;
}

.table-responsive th,
.table-responsive td {
  padding: 8px 12px;
  text-align: left;
  white-space: nowrap;
}

.custom-table {
  --bs-table-bg: var(--surface);
  --bs-table-color: var(--text-primary);
  --bs-table-border-color: var(--border-color);
  width: 100%;
  margin-bottom: 0;
  border-collapse: collapse;
  min-width: fit-content;
}

body {
  overflow-x: hidden !important;
  /* Ensures no body content forces a wider layout */
}

::-webkit-scrollbar {
  width: 5px;
  height: 5px;
}

::-webkit-scrollbar-track {
  background: var(--scroll-track);
}

::-webkit-scrollbar-thumb {
  background: var(--scroll-thumb);
  transition: background 0.3s ease;
}

::-webkit-scrollbar-thumb:hover {
  background: var(--scroll-thumb-hover);
}

.custom-table th,
.custom-table td {
  padding: 10px 15px;
  vertical-align: middle;
  border-bottom: 1px solid var(--border-color);
}

/* --- Table Header (The top row with titles) --- */
.custom-table thead tr {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--surface-hover);
}

.custom-table th {
  font-weight: 600;
  color: var(--text-secondary);
  cursor: pointer;
  position: relative;
  user-select: none;
}

.table-header-sticky {
  position: sticky;
  top: 0;
  z-index: 10;
  background-color: var(--surface-hover);
}

/* --- Table Body Rows --- */
.custom-table tbody tr {
  transition: background-color 0.2s;
}

.custom-table tbody tr:hover {
  background-color: var(--surface-hover);
}

/* --- Status Cell (Specifically for 'Success' as seen in the image) --- */
.custom-table td .success {
  /* Uses the success badge variables from the dark theme */
  background-color: var(--badge-success);
  color: var(--badge-success-text);
  padding: 3px 8px;
  border-radius: 4px;
  font-size: 0.85rem;
  font-weight: 600;
  display: inline-block;
}

/* --- Sort Buttons on Header --- */
.sort-buttons {
  display: inline-flex;
  flex-direction: column;
  margin-left: 5px;
  position: absolute;
  right: 5px;
  top: 50%;
  transform: translateY(-50%);
}

.svg-button {
  background: none;
  border: none;
  padding: 0;
  margin: 0;
  height: 10px;
  width: 10px;
  cursor: pointer;
}

.svg-icon {
  fill: var(--text-primary);
  opacity: 0.5; /* Lighter/Dimmer sort icon */
}

/* --- Table Row Elements (Process column for Process Details tab) --- */
.btn-mermaid {
  color: var(--primary); /* Primary color for interactive links */
  text-decoration: none;
  cursor: pointer;
  font-weight: 500;
}

.expand-icon-fixed {
  position: absolute;
  right: 0;
  top: 50%;
  transform: translateY(-50%);
  padding-left: 10px;
}

.btn-link {
  color: var(--primary);
  text-decoration: none;
}

.btn-link i {
  font-size: 1.1rem;
}

/* --- Child Table Row --- */
td[style*="background:#f9f9f9;"] {
  background: var(--surface-active) !important;
  border-top: 1px solid var(--border-color);
}

/* --- Pagination Bar --- */
.pagination-bar {
  background: var(--surface);
  padding: 10px 15px;
  border-radius: 0 0 5px 5px;
  margin-top: -1px;
  border: 1px solid var(--border-color);
  border-top: none;
}

/* --- Checkbox Styles --- */
.form-check-input {
  background-color: var(--surface);
  border: 1px solid var(--text-secondary);
  cursor: pointer;
}

.form-check-input:checked {
  background-color: var(--primary);
  border-color: var(--primary);
}

/* --- Modal Styles (Optional, for completeness) --- */

/* --- Modal Structure Styles --- */

.modal-overlay {
  /* Full screen coverage with a translucent background */
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  /* Uses the shadow-strong variable for a dark, noticeable overlay */
  background-color: rgba(
    0,
    0,
    0,
    0.7
  ); /* Darker backdrop for visibility in dark mode */
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000; /* Ensure it is above all other content */
  backdrop-filter: blur(2px); /* Subtle blur effect */
}

.ai-modal-content {
  /* The modal itself - centered on the screen */
  background-color: var(--surface); /* Dark mode surface color */
  color: var(--text-primary); /* Dark mode primary text color */
  border-radius: 8px;
  box-shadow: 0 10px 20px var(--shadow-strong);
  width: 90%;
  max-width: 700px; /* Comfortable max width for options */
  animation: fadeIn 0.3s ease-out; /* Simple entry animation */
  border: 1px solid var(--border-color); /* Subtle border */
}

.modal-header {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 15px 20px;
  border-bottom: 1px solid var(--border-color);
}

.modal-header h3 {
  margin: 0;
  font-size: 1.5rem;
  color: var(--text-primary);
  font-weight: 600;
}

.close-button {
  background: none;
  border: none;
  font-size: 1.8rem;
  color: var(--text-secondary);
  cursor: pointer;
  transition: color 0.2s;
}

.close-button:hover {
  color: var(--error); /* Use error color for a clear "close" action */
}

.modal-body {
  padding: 20px;
  max-height: 70vh; /* Prevents modal from getting too tall */
  overflow-y: auto;
}

.modal-footer {
  display: flex;
  justify-content: flex-end;
  gap: 10px;
  padding: 15px 20px;
  border-top: 1px solid var(--border-color);
  background-color: var(
    --surface-hover
  ); /* Slightly different background for the footer */
  border-radius: 0 0 8px 8px;
}

/* --- Options & Radio Button Styles (Language Section) --- */

.options-section {
  margin-bottom: 25px;
}

.options-section h4 {
  color: var(--text-primary);
  font-size: 1.1rem;
  margin-bottom: 10px;
  font-weight: 600;
  border-bottom: 1px solid var(--border-color);
  padding-bottom: 5px;
}

/* No Records */
.no-records {
  padding: 60px 20px !important;
  text-align: center;
  color: var(--text-secondary);
}

.no-records-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 16px;
}

.no-records-content p {
  margin: 0;
  font-size: 16px;
  color: var(--text-secondary);
  font-weight: 500;
}


.radio-group {
  display: flex;
  gap: 20px;
}

.radio-label {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--text-primary);
  transition: color 0.1s;
}

.radio-label.disabled {
  opacity: 0.5;
  cursor: not-allowed;
  color: var(--text-secondary);
}

.radio-label input[type="radio"] {
  /* Hide default radio and create custom one */
  opacity: 0;
  width: 0;
  height: 0;
}

.radio-text {
  position: relative;
  padding-left: 25px; /* Space for the custom radio button */
}

.radio-text::before {
  content: "";
  position: absolute;
  left: 0;
  top: 50%;
  transform: translateY(-50%);
  width: 16px;
  height: 16px;
  border-radius: 50%;
  border: 2px solid var(--border-color);
  background-color: var(--surface);
  transition: all 0.2s;
}

.radio-label:hover .radio-text::before {
  border-color: var(--primary);
}

.radio-label input[type="radio"]:checked + .radio-text::before {
  border-color: var(--primary);
  background-color: var(--primary);
}

.radio-label input[type="radio"]:checked + .radio-text::after {
  content: "";
  position: absolute;
  left: 4px; /* Center the dot */
  top: 50%;
  transform: translateY(-50%);
  width: 8px;
  height: 8px;
  border-radius: 50%;
  background-color: var(--text-primary); /* White dot on primary background */
  z-index: 1;
}

.radio-label.disabled:hover .radio-text::before {
  border-color: var(--border-color); /* Remove hover highlight for disabled */
}

/* --- Questions Table Styles --- */

.questions-section {
  margin-top: 20px;
}

.questions-table {
  width: 100%;
  border-collapse: collapse;
}

.questions-table tr {
  border-bottom: 1px solid var(--border-color);
}

.questions-table tr:last-child {
  border-bottom: none;
}

.questions-table td {
  padding: 12px 10px;
  color: var(--text-primary);
  font-size: 0.95rem;
}

.questions-table tr td:first-child {
  width: 70%;
}
.questions-table tr td:last-child {
  width: 30%;
  text-align: right;
}

/* Smaller text for migration notes */
.questions-table small {
  color: var(--text-secondary) !important;
  font-size: 0.8rem;
  display: block;
  margin-top: 5px;
}

/* --- Question Radio Options (Yes/No) --- */

.radio-options {
  display: flex;
  justify-content: flex-end;
  gap: 15px;
}

.radio-option {
  display: flex;
  align-items: center;
  cursor: pointer;
  color: var(--text-primary);
  font-weight: 500;
}

.radio-option input[type="radio"] {
  /* Uses the base checkbox styles from the previous response for consistency */
  background-color: var(--surface);
  border: 1px solid var(--primary);
  cursor: pointer;
  margin-right: 5px;
}

.radio-option input[type="radio"]:checked {
  background-color: var(--primary);
  border-color: var(--primary);
}

/* --- Modal Footer Buttons --- */

.btn-cancel {
  /* Ghost/Secondary button style */
  background-color: var(--surface-active);
  color: var(--text-primary);
  border: 1px solid var(--border-color);
  padding: 8px 15px;
  border-radius: 5px;
  font-weight: 500;
  transition: background-color 0.2s;
}

.btn-cancel:hover {
  background-color: var(--surface-active);
}

.btn-generate {
  /* Primary Action Button */
  background-color: var(--primary);
  color: var(
    --text-primary
  ); /* Use text-primary for contrast on primary in dark mode */
  border: 1px solid var(--primary);
  padding: 8px 15px;
  border-radius: 5px;
  font-weight: 500;
  transition: background-color 0.2s, opacity 0.2s;
}

.btn-generate:hover:not(.disabled) {
  background-color: var(--primary-hover);
  border-color: var(--primary-hover);
}

.btn-generate.disabled {
  opacity: 0.6;
  cursor: not-allowed;
  background-color: var(
    --primary-bg
  ); /* Use a lighter primary background when disabled */
  color: var(--text-secondary);
  border-color: var(--primary-bg);
}

/* Keyframe for Modal Entry */
@keyframes fadeIn {
  from {
    opacity: 0;
    transform: translateY(-20px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}
</style>
